import React from 'react';
import PropTypes from 'prop-types';

import {Group} from "../../../shared/components/Group";
import {Checkbox} from "../../../shared/components/Checkbox";

export default function Seniors({seniors, onCheckbox}) {
  return (
    <Group title={__("Who do you want to send the picture to?")}
           itemType="selectItem">
      {seniors.map((member, memberIndex) => {
        return (
          <div className="flexBox direction-row center-center"
               key={memberIndex}>
            <div className="userProfilePic"
                 style={{backgroundImage: `url(${member.imgUrl})`}}
            />
            <div className="flex memberName">
              {member.firstname} {member.lastname}
            </div>
            {typeof member.checkbox === "boolean" && (
              <Checkbox checked={member.checkbox}
                        device={`${member.device_id}`}
                        prof={`${member.prof_id}`}
                        onChange={onCheckbox}
              />
            )}
          </div>
        );
      })}
    </Group>
  );
}

Seniors.propTypes = {
  seniors: PropTypes.arrayOf(PropTypes.shape({
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    imgUrl: PropTypes.string.isRequired,
    checkbox: PropTypes.bool.isRequired,
    device_id: PropTypes.number.isRequired,
    prof_id: PropTypes.number.isRequired
  })),
  onCheckbox: PropTypes.func.isRequired
};
